import { ApiErrorDTO, ApiErrorDTOErrorsItem } from "./apis";

export class APIError extends Error {
  code: string;
  errors?: ApiErrorDTOErrorsItem[];
  message: string;
  status: number;
  timestamp: string;

  constructor(message: string, data: ApiErrorDTO) {
    super(message);
    this.code = data.code;
    this.errors = data.errors;
    this.message = data.message;
    this.status = data.status;
    this.timestamp = data.timestamp;

    Object.setPrototypeOf(this, APIError.prototype);
  }
}

export function isApiErrorResponse(
  response: ApiErrorDTO
): response is ApiErrorDTO {
  return (
    response &&
    "code" in response &&
    "message" in response &&
    "timestamp" in response &&
    "status" in response
  );
}
